// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"834":"2a1b50a47636de1ef811","926":"90c63f89bf5aaf79313b"}[chunkId] + ".chunk.js";
};